<template>
  <div class="box">
    <el-card
      shadow="always"
      style="margin-left: 12px; width: 98.6%; height: 150px"
    >
      <div slot="header" class="clearfix">
        <span>服务器磁盘状态</span>
      </div>
      <div class="top">
        <div class="top_disk">
          <div style="color: #06c0f3; min-width: 100px">中心服务器</div>
          <el-progress
            v-for="(item, i) in SystemStatus.centerServerDisk"
            :key="i"
            :percentage="setItemProgress(item)"
            :color="customColors"
            :text-inside="true"
            :stroke-width="28"
            style="width: 400px; margin: 0 5px"
            text-color="#000"
            :format="format(item)"
          ></el-progress>
        </div>
        <div class="top_disk">
          <div style="color: #06c0f3; min-width: 100px">媒体服务器</div>
          <el-progress
            v-for="(item, i) in SystemStatus.mediaServerDisk"
            :key="i"
            :percentage="setItemProgress(item)"
            :color="customColors"
            :text-inside="true"
            :stroke-width="28"
            style="width: 400px; margin: 0 5px"
            text-color="#000"
            :format="format(item)"
          ></el-progress>
        </div>
      </div>
    </el-card>

    <div class="center">
      <el-card shadow="always" style="width: 65.3%; height: 350px">
        <div slot="header" class="clearfix">
          <span>文件存储设置</span>
        </div>
        <div class="centerBigBox">
          <div class="smallBox">
            <div class="Title">文件存储位置</div>

            <el-checkbox-group v-model="mediaDiskType" class="checkboxBox">
              <el-checkbox
                v-for="(item, index) in SystemStatus.mediaServerDisk"
                :key="index"
                :label="item.disk"
                name="disk"
              ></el-checkbox>
            </el-checkbox-group>

            <el-button
              type="primary"
              icon="el-icon-check"
              @click="
                Update('media_server_storage_disk', mediaDiskType.join(','))
              "
              >保存</el-button
            >
          </div>
          <div class="smallBox">
            <div class="Title">数据库备份</div>
            <el-radio-group class="radioBox" style="" v-model="databaseBackup">
              <el-radio label="1">1天/次</el-radio>
              <el-radio label="7">7天/次</el-radio>
              <el-radio label="30">30天/次</el-radio>
              <el-radio label="0">不备份</el-radio>
            </el-radio-group>

            <el-button
              type="primary"
              icon="el-icon-check"
              @click="Update('database_backup_interval', databaseBackup)"
              >保存</el-button
            >
          </div>
          <div class="smallBox">
            <div class="Title">实时视频存储</div>
            <el-radio-group class="radioBox" v-model="mediaSave">
              <el-radio label="false">不保存</el-radio>
              <el-radio label="true">保存</el-radio>
            </el-radio-group>

            <el-button
              type="primary"
              icon="el-icon-check"
              @click="Update('media_server_save_stream', mediaSave)"
              >保存</el-button
            >
          </div>
          <div class="smallBox">
            <div class="Title">文件保存天数</div>
            <el-radio-group class="radioBox" v-model="mediaFileDay">
              <el-radio label="90">90天</el-radio>
              <el-radio label="180">180天</el-radio>
              <el-radio label="365">365天</el-radio>
              <el-radio label="730">730天</el-radio>
              <el-radio label="36500">不删除</el-radio>
            </el-radio-group>

            <el-button
              type="primary"
              icon="el-icon-check"
              @click="Update('media_server_storage_expire', mediaFileDay)"
              >保存</el-button
            >
          </div>
          <div class="smallBox">
            <div class="Title">GPS保存天数</div>
            <el-radio-group class="radioBox" v-model="gpsHistoryDay">
              <el-radio label="90">90天</el-radio>
              <el-radio label="180">180天</el-radio>
              <el-radio label="365">365天</el-radio>
              <el-radio label="730">730天</el-radio>
              <el-radio label="36500">不删除</el-radio>
            </el-radio-group>

            <el-button
              type="primary"
              icon="el-icon-check"
              @click="Update('gps_history_expire', gpsHistoryDay)"
              >保存</el-button
            >
          </div>
          <div class="smallBox">
            <div class="Title">日志保存天数</div>
            <el-radio-group class="radioBox" v-model="systemLogExpire">
              <el-radio label="90">90天</el-radio>
              <el-radio label="180">180天</el-radio>
              <el-radio label="365">365天</el-radio>
              <el-radio label="730">730天</el-radio>
              <el-radio label="36500">不删除</el-radio>
            </el-radio-group>

            <el-button
              type="primary"
              icon="el-icon-check"
              @click="Update('system_log_expire', systemLogExpire)"
              >保存</el-button
            >
          </div>
        </div>
      </el-card>
      <el-card shadow="always" style="width: 32%; height: 350px">
        <div slot="header" class="clearfix">
          <span>服务器状态</span>
        </div>
        <div style="display: flex; justify-content: space-around">
          <div
            id="StatusCPU"
            ref="StatusCPU"
            style="width: 50%; height: 320px"
          ></div>
          <div
            id="StatusMemory"
            ref="StatusMemory"
            style="width: 50%; height: 320px"
          ></div>
        </div>
      </el-card>
    </div>

    <div class="bottom">
      <el-card shadow="always" style="width: 32%; height: 250px">
        <div slot="header" class="clearfix">
          <span>媒体服务器IP和端口设置</span>
        </div>
        <div class="bigBox">
          <div class="smallBox">
            <label
              style="
                padding: 10px 15px;
                text-shadow: 0 1px 0 rgba(19, 74, 70, 0.4);
                background: #377d6a;
                color: floralwhite;
                border-top-left-radius: 3px;
                border-bottom-left-radius: 3px;
                display: block;
                position: absolute;
                left: 3.3%;
              "
              >内 网 I P</label
            >
            <el-select
              style="
                display: inline-block;
                width: 400px;
                color: #377d6a !important;
                background: #fff;
                margin: 0 10px 0 88px;
              "
              v-model="mediaServerCheckLocalIp"
              placeholder="请选择"
            >
              <el-option
                v-for="item in this.mediaServerLocalIpAry"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>

            <el-button
              type="primary"
              icon="el-icon-check"
              @click="
                Update('media_server_check_local_ip', mediaServerCheckLocalIp)
              "
              >保存</el-button
            >
          </div>
          <div class="smallBox">
            <input
              class="card-slide"
              id="knock"
              type="text"
              placeholder="请输入媒体服务器外网IP!"
              v-model="mediaIp"
            />
            <label for="knock">外 网 I P</label>
            <el-button
              type="primary"
              icon="el-icon-check"
              @click="Update('media_server_out_ip', mediaIp)"
              >保存</el-button
            >
          </div>
          <div class="smallBox">
            <input
              class="card-slide"
              id="knock"
              type="number"
              v-model="mediaPort"
              placeholder="请输入媒体服务器文件播放端口!"
            />
            <label for="knock">文件端口</label>
            <el-button
              type="primary"
              icon="el-icon-check"
              @click="Update('media_server_play_port', mediaPort)"
              >保存</el-button
            >
          </div>
        </div>
      </el-card>
      <el-card shadow="always" style="width: 32%; height: 250px">
        <div slot="header" class="clearfix">
          <span>平台标题和LOGO</span>
        </div>
        <!-- <div
          class="bigBox"
          v-for="(item, index) in this.SystemSettingValues"
          :key="index"
        >
          <input
            v-if='item.settingKey == "system_title"'
            class="gate"
            id="class"
            type="text"
            placeholder="请输入系统标题!"
            maxlength="12"
            v-model="item.settingValue"
          />
          <label for="class">平台标题</label> -->
        <div class="bigBox">
          <div class="smallBox">
            <input
              class="gate"
              id="class"
              type="text"
              placeholder="请输入系统标题!"
              maxlength="12"
              v-model="webTitle"
            />
            <label for="class">平台标题</label>

            <!-- <div class="Title">系统标题</div>
          <el-input
            class="inputBox"
            type="text"
            placeholder="请输入系统标题"
            v-model="text"
            maxlength="12"
            show-word-limit
          >
          </el-input> -->
            <el-button
              type="primary"
              icon="el-icon-check"
              @click="Update('system_title', webTitle)"
              >保存</el-button
            >
          </div>
          <div class="smallBox">
            <!-- <div class="Title">平台LOGO</div> -->
            <!-- 表单区域 -->
            <el-form
              ref="LogoFormRef"
              :model="logoFile"
              label-width="100px"
              class="upload_Logo"
            >
              <el-form-item label="平台LOGO" class="logoLabel">
                <el-upload
                  class="avatar-uploader"
                  action="sss"
                  list-type="picture-card"
                  :class="{ disabled: uploadDisabled }"
                  :auto-upload="false"
                  :limit="1"
                  ref="logoUpload"
                  :on-change="logoHandleChange"
                  :on-preview="logoHandlePictureCardPreview"
                  :on-remove="logoHandleRemove"
                  :file-list="logoFileList"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <!-- 预览图片 -->
                <el-dialog :visible.sync="logoDialogVisibleimg" append-to-body>
                  <img width="100%" :src="logoDialogImageUrl" alt="" />
                </el-dialog>
              </el-form-item>
            </el-form>

            <el-button type="primary" icon="el-icon-check" @click="UpdateLogo()"
              >保存</el-button
            >
          </div>
        </div>
      </el-card>
      <el-card shadow="always" style="width: 32%; height: 250px">
        <div slot="header" class="clearfix">
          <span>其他</span>
        </div>
        <div class="bigBox">
          <div class="smallBox">
            <div class="Title">平台授权信息</div>
            <el-button
              type="primary"
              icon="el-icon-s-promotion"
              @click="openXlhDialogVisible()"
              >点击获取平台授权信息</el-button
            >
          </div>
          <div class="smallBox">
            <div class="Title">上传授权文件</div>
            <el-upload
              class="upload-demo"
              action="sss"
              :file-list="fileList"
              :auto-upload="false"
              :on-change="handleChange"
              :on-remove="removeFile"
              :limit="1"
            >
              <el-button type="success">选取文件</el-button>
            </el-upload>
            <el-button
              style="margin-left: 5px"
              type="primary"
              @click="uploadLicenseFile()"
              icon="el-icon-upload"
              >上传文件</el-button
            >
          </div>
          <div class="smallBox">
            <div class="Title">上传终端APK</div>
            <el-upload
              class="upload-demo"
              action="ss"
              :file-list="fileList"
              :show-file-list="true"
              :auto-upload="false"
              :on-change="ApkHandleChange"
              :on-remove="removeApkFile"
              :limit="1"
            >
              <el-button type="success">选取文件</el-button>
            </el-upload>

            <el-button
              style="margin-left: 5px"
              type="primary"
              @click="uploadApkFile()"
              icon="el-icon-upload"
              >上传文件</el-button
            >
          </div>
        </div>
      </el-card>
    </div>
    <el-dialog
      title="平台授权信息"
      :visible.sync="xlhDialogVisible"
      width="30%"
    >
      <div style="color: #06c0f3; font-size: 1rem">
        平台序列号:
        <span
          style="
            color: #03a2f8;
            user-select: text;
            -moz-user-select: text;
            -ms-user-select: text;
            -webkit-user-select: text;
          "
          >{{ xlh }}</span
        >
      </div>
      <div style="color: #06c0f3; font-size: 1rem; margin: 10px 0">
        授权状态:
        <span style="color: #03a2f8">{{
          this.LicenseStatus.status == 0
            ? "已授权" + "(" + this.LicenseStatus.yixg + "台)"
            : "未授权" + "(" + this.LicenseStatus.yixg + "台)"
        }}</span>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="xlhDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="xlhDialogVisible = false"
          >确 定</el-button
        >
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
// 引入echarts图标
import * as echarts from "echarts";
export default {
  data() {
    return {
      // 服务器状态信息
      SystemStatus: [],
      // 进度条颜色
      customColors: [
        { color: "#0f97f8", percentage: 80 },
        { color: "#f3c808", percentage: 90 },
        { color: "#f30808", percentage: 100 },
      ],
      // 设置定时器
      setInt: null,
      // 系统参数设置值
      SystemSettingValues: [],
      // 平台标题
      webTitle: "",
      // 媒体文件储存位置
      mediaDiskType: [],
      // 实时视频是否保存
      mediaSave: "",
      // 媒体服务器文件的保存天数
      mediaFileDay: "",
      // 数据库备份周期（天
      databaseBackup: "",
      // GPS文件保存的天数
      gpsHistoryDay: "",
      //日志保存的天数
      systemLogExpire: "",
      // 媒体服务器文件播放端口
      mediaPort: "",
      // 媒体服务器关联的外网ip
      mediaIp: "",
      // 媒体服务器所有的内网ip
      mediaServerLocalIpAry: [],
      // 媒体服务器选中的内网ip
      mediaServerCheckLocalIp: "",
      // 上传文件列表
      fileList: [],
      formdata: new FormData(),
      // 授权文件
      licenseFile: "",
      // 序列号
      xlh: "",
      // 平台授权信息对话框
      xlhDialogVisible: false,
      //平台授权状态信息
      LicenseStatus: {},
      //终端升级apk
      apkFile: "",
      progressPercent: 0, // 进度条默认为0
      // 系统默认LOGO
      logoFile: {
        file: "",
        logoImg: "",
      },
      //上传LOGO查看LOGO对话框
      logoDialogVisibleimg: false,
      // 上传LOGO查看
      logoDialogImageUrl: "",
      logoFormdata: new FormData(),
      logoFileList: [],
      logoAddimg: [],
    };
  },
  created() {
    // 获取系统参数设置
    this.getSystemSetting();
  },
  mounted() {
    // 进入界面获取服务状态信息
    this.getSystemStatus();
  },
  beforeUpdate() {
    // 设置1分钟发送请求一次获取服务器状态
    this.setInt = setTimeout(() => {
      this.getSystemStatus();
    }, 60000);
  },
  //离开页面清除获取服务器状态定时器
  beforeRouteLeave(to, from, next) {
    clearTimeout(this.setInt);
    next();
  },
  computed: {
    uploadDisabled: function () {
      return this.logoFile.file != "";
    },
  },
  methods: {
    // 获取服务状态信息
    async getSystemStatus() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/getSystemStatus`
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      if (res.data) {
        this.SystemStatus = res.data;
        // 获取CPU信息
        this.StatusCPU();
        // 获取运行内存
        this.StatusMemory();
      }
    },
    // 磁盘进度条文字内容
    format(row) {
      return () => {
        return `${row.disk.slice(0, 1)}:${Math.floor(
          row.free / 1024 / 1024 / 1024
        )}G/${Math.floor(row.total / 1024 / 1024 / 1024)}G`;
      };
    },
    // 求百分比
    setItemProgress(data) {
      return parseInt(((data.total - data.free) / data.total).toFixed(1) * 100);
    },
    //cpu状态
    StatusCPU() {
      if (this.$refs.StatusCPU) {
        this.$nextTick(() => {
          var StatusCPU = echarts.getInstanceByDom(this.$refs.StatusCPU);
          if (StatusCPU == null) {
            StatusCPU = echarts.init(this.$refs.StatusCPU);
          }

          var option;
          option = {
            series: [
              {
                type: "gauge",
                axisLine: {
                  lineStyle: {
                    width: 30,
                    color: [
                      [0.3, "#67e0e3"],
                      [0.7, "#37a2da"],
                      [1, "#fd666d"],
                    ],
                  },
                },
                // 仪表盘半径
                radius: "90%",
                pointer: {
                  itemStyle: {
                    color: "auto",
                  },
                },
                axisTick: {
                  distance: -30,
                  length: 8,
                  lineStyle: {
                    color: "#fff",
                    width: 2,
                  },
                },
                splitLine: {
                  distance: -30,
                  length: 30,
                  lineStyle: {
                    color: "#fff",
                    width: 4,
                  },
                },
                axisLabel: {
                  color: "inherit",
                  distance: 40,
                  fontSize: 15,
                },
                // 百分比数值
                detail: {
                  valueAnimation: true,
                  formatter: "{value} %",
                  color: "inherit",
                  fontSize: 22,
                  offsetCenter: ["0", "70%"],
                },
                // 标题
                title: {
                  color: "rgba(13, 251, 243, 0.65)",
                  fontSize: 25,
                  offsetCenter: ["0", "95%"], //相对于仪表盘中心的偏移位置，数组第一项是水平方向的偏移，第二项是垂直方向的偏移
                },

                data: [
                  {
                    value: this.SystemStatus.cpu,
                    name: "CPU状态",
                  },
                ],
              },
            ],
          };
          option && StatusCPU.setOption(option);
          window.addEventListener("resize", function () {
            StatusCPU.resize();
          });
        });
      }
    },
    // 运行内存
    StatusMemory() {
      if (this.$refs.StatusMemory) {
        this.$nextTick(() => {
          var StatusMemory = echarts.getInstanceByDom(this.$refs.StatusMemory);
          if (StatusMemory == null) {
            StatusMemory = echarts.init(this.$refs.StatusMemory);
          }

          var option;
          option = {
            series: [
              {
                type: "gauge",
                axisLine: {
                  lineStyle: {
                    width: 30,
                    color: [
                      [0.3, "#67e0e3"],
                      [0.7, "#37a2da"],
                      [1, "#fd666d"],
                    ],
                  },
                },
                // 仪表盘半径
                radius: "90%",
                pointer: {
                  itemStyle: {
                    color: "auto",
                  },
                },
                axisTick: {
                  distance: -30,
                  length: 8,
                  lineStyle: {
                    color: "#fff",
                    width: 2,
                  },
                },
                splitLine: {
                  distance: -30,
                  length: 30,
                  lineStyle: {
                    color: "#fff",
                    width: 4,
                  },
                },
                axisLabel: {
                  color: "inherit",
                  distance: 35,
                  fontSize: 15,
                },
                detail: {
                  valueAnimation: true,
                  formatter: "{value} %",
                  color: "inherit",
                  fontSize: 22,
                  offsetCenter: ["0", "70%"],
                },
                title: {
                  color: "rgba(13, 251, 243, 0.65)",
                  fontSize: 25,
                  offsetCenter: ["0", "95%"], //相对于仪表盘中心的偏移位置，数组第一项是水平方向的偏移，第二项是垂直方向的偏移
                },

                data: [
                  {
                    value: this.SystemStatus.memory,
                    name: "内存状态",
                  },
                ],
              },
            ],
          };
          option && StatusMemory.setOption(option);
          window.addEventListener("resize", function () {
            StatusMemory.resize();
          });
        });
      }
    },
    // 获取系统设置参数
    async getSystemSetting() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/setting/search`
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      if (res.data) {
        this.SystemSettingValues = res.data;
        for (let i = 0; i < this.SystemSettingValues.length; i++) {
          // 平台默认标题
          if (this.SystemSettingValues[i].settingKey == "system_title") {
            this.webTitle = this.SystemSettingValues[i].settingValue;
          }
          //平台默认LOGO
          if (this.SystemSettingValues[i].settingKey == "system_logo") {
            this.logoFile.logoImg = this.SystemSettingValues[i].settingValue;
          }
          // 媒体服务器全部内网ip
          if (
            this.SystemSettingValues[i].settingKey == "media_server_local_ip"
          ) {
            var AryIp = this.SystemSettingValues[i].settingValue;
            this.mediaServerLocalIpAry = AryIp.split(",");
          }
          // 媒体服务器选中的内网ip
          if (
            this.SystemSettingValues[i].settingKey ==
            "media_server_check_local_ip"
          ) {
            this.mediaServerCheckLocalIp =
              this.SystemSettingValues[i].settingValue;
          }
          // 媒体服务器关联的外网ip
          if (this.SystemSettingValues[i].settingKey == "media_server_out_ip") {
            this.mediaIp = this.SystemSettingValues[i].settingValue;
          }
          // 媒体服务器文件播放端口
          if (
            this.SystemSettingValues[i].settingKey == "media_server_play_port"
          ) {
            this.mediaPort = this.SystemSettingValues[i].settingValue;
          }
          // 媒体文件储存位置
          if (
            this.SystemSettingValues[i].settingKey ==
            "media_server_storage_disk"
          ) {
            this.mediaDiskType =
              this.SystemSettingValues[i].settingValue.split(",");
          }
          // 实时视频是否保存
          if (
            this.SystemSettingValues[i].settingKey == "media_server_save_stream"
          ) {
            this.mediaSave = this.SystemSettingValues[i].settingValue;
          }
          // 媒体服务器文件的保存天数
          if (
            this.SystemSettingValues[i].settingKey ==
            "media_server_storage_expire"
          ) {
            this.mediaFileDay = this.SystemSettingValues[i].settingValue;
          }
          // 数据库备份周期（天）
          if (
            this.SystemSettingValues[i].settingKey == "database_backup_interval"
          ) {
            this.databaseBackup = this.SystemSettingValues[i].settingValue;
          }
          //GPS文件保存的天数
          if (this.SystemSettingValues[i].settingKey == "gps_history_expire") {
            this.gpsHistoryDay = this.SystemSettingValues[i].settingValue;
          }
          //日志保存的天数
          if (this.SystemSettingValues[i].settingKey == "system_log_expire") {
            this.systemLogExpire = this.SystemSettingValues[i].settingValue;
          }
        }
      }
      this.$nextTick(() => {
        this.logoDialogImageUrl = this.logoFile.logoImg;
        this.logoFile.file = [this.logoFile.logoImg];
        // 给默认LOGO赋值显示
        this.LogoApply(this.logoFile.logoImg);
      });
    },

    // 修改服务器配置
    async Update(settingKey, settingExplain) {
      const { data: res } = await this.$axios.put(
        `${this.$api}/setting/modfiy`,

        {
          settingKey: settingKey,
          settingValue: settingExplain,
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.$message.success("更新配置成功");

      if (
        settingKey == "system_title" ||
        settingKey == "media_server_check_local_ip"
      ) {
        location.reload();
      }
      this.getSystemSetting();
    },
    // 打开平台授权信息对话框
    openXlhDialogVisible() {
      this.xlhDialogVisible = true;
      this.getSerial();
      this.getLicenseStatus();
    },
    // 获取平台序列号
    async getSerial() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/license/getSerial`
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.xlh = res.data.serial;
    },
    //获取平台授权状态
    async getLicenseStatus() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/license/getLicenseStatus`
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.LicenseStatus = res.data;
    },

    //  上传授权文件
    async uploadLicenseFile() {
      if (this.licenseFile == "") {
        return this.$message.warning({ message: "请选择授权文件" });
      }
      this.formdata = new FormData();
      this.formdata.append("file", this.licenseFile);
      const { data: res } = await this.$axios.post(
        `${this.$api}/license/uploadLicenseFile`,
        this.formdata
      );
      if (res.status != 0) {
        this.licenseFile = "";
        this.fileList = [];
        return this.$message.error(res.msg);
      }
      this.$message.success({ message: "授权成功" });
      this.licenseFile = "";
      this.fileList = [];
    },
    //  上传终端apk
    async uploadApkFile() {
      if (this.apkFile == "") {
        return this.$message.warning({ message: "请选择需上传的APK文件" });
      }
      this.formdata = new FormData();
      this.formdata.append("apkFile", this.apkFile);
      const { data: res } = await this.$axios.post(
        `${this.$api}/apk/upload`,
        this.formdata
      );

      if (res.status != 0) {
        this.apkFile = "";
        this.fileList = [];
        return this.$message.error(res.msg);
      }
      this.$message.success({ message: "上传成功" });
      this.apkFile = "";
      this.fileList = [];
    },
    handleChange(file) {
      const isLt10KB = file.size / 1024 < 10;
      if (!isLt10KB) {
        this.$message.error("上传文件不能大于10KB");
        this.fileList = [];
        return isLt10KB;
      }
      this.licenseFile = file.raw;
    },
    // 改变终端apk升级文件出发
    ApkHandleChange(file) {
      // 获取浏览器
      const agent = navigator.userAgent;
      var isAPK;
      //  如果是火狐就不判断是不是apk
      if (agent.indexOf("Firefox") > 0) {
        isAPK = true;
      } else {
        isAPK = file.raw.type === "application/vnd.android.package-archive";
      }
      const isLt200M = file.size / 1024 / 1000 < 200;
      if (!isLt200M || !isAPK) {
        this.$message.error("上传文件必须是APK格式且不能大于200M");
        this.fileList = [];
        return isLt200M;
      }
      this.apkFile = file.raw;
    },
    // 移除授权文件
    removeFile() {
      this.licenseFile = "";
    },
    // 移除终端升级APK文件
    removeApkFile() {
      this.apkFile = "";
    },
    // 添加Logo图片
    logoHandleChange(file, fileList) {
      const isJPG =
        file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 1;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 、png 格式!");
        fileList.splice(-1, 1); //移除错误文件
        return false;
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 1MB!");
        fileList.splice(-1, 1);
        return false;
      }

      let img = new Image();
      img.src = file.url;
      let _this = this;
      img.onload = (e) => {
        let imgWidth = img.width;
        let imgHeight = img.height;
        if (imgWidth > 100 || imgHeight > 100) {
          _this.$message.error("上传图片宽高不能超过  100px!");
          fileList.splice(-1, 1); //移除错误文件
          return false;
        } else {
          this.logoAddimg = fileList[0].raw;
          this.logoFile.file = this.logoAddimg;
        }
      };
    },
    // 删除logo展示照片
    logoHandleRemove(file, fileList) {
      this.$refs.logoUpload.clearFiles(); //清除图片
      this.logoFile.file = "";
      this.logoFormdata = new FormData();
    },
    // logo展示照片预览
    logoHandlePictureCardPreview(file) {
      this.logoDialogImageUrl = file.url;
      this.logoDialogVisibleimg = true;
    },
    // 渲染编辑获取id
    LogoApply(res) {
      this.logoFileList = [{ url: "" }]; //这里是踩坑的点，必须写
      this.logoFileList[0].url = "data:image/png;base64," + res; //这里是调用接口获取到的值 res.data.flImg，赋值就可以回显了
      //this.fileList[0].url 做的是单张图片回显，多张图片回显可以去掉[0]
    },
    // 修改默认网页LOGO
    async UpdateLogo() {
      this.logoFormdata = new FormData();
      //新增
      this.logoFormdata.append("file", this.logoFile.file); //上传图片要把参数和值放在FormData里
      const { data: res } = await this.$axios.post(
        `${this.$api}/setting/upload/system/logo`,
        this.logoFormdata
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.$message.success("修改成功");
      location.reload();
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  height: 100%;
  // background-image: url(../../../assets/img/dataBoard/box1.png);
  // /*  背景图片平铺 */
  // background-repeat: repeat;
  // background-size: 100% 100%;
  // opacity: 0.8;
  // z-index: 10;
}
// 上面磁盘容量显示框
.top {
  height: 120px;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  padding: 5px 10px;

  .top_disk {
    height: 50px;
    display: flex;

    // align-items: center;
  }
}

// 中间显示框
.center {
  display: flex;
  justify-content: space-around;
  padding: 10px 0;
}
// 下面显示框
.bottom {
  display: flex;
  justify-content: space-around;
  padding-bottom: 10px;
}
//el-card 头部标题样式
/deep/ .el-card__header {
  padding: 10px 20px !important;
  color: aqua;
}
//el-card  内容区域样式
/deep/.el-card__body {
  padding: 0;
}

// el-progress  进度条文字样式
/deep/.el-progress-bar__innerText {
  font-size: 18px;
  font-weight: 600;
}

.bigBox {
  height: 200px;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  margin: 0 50px;
  .smallBox {
    display: flex;
    align-items: center;
    .Title {
      color: #06c0f3;
      width: 150px;
    }
    .inputBox {
      // margin: 0 10px;
      width: 400px;
    }
    .checkboxBox {
      margin: 5px 10px;
      border: 1px dotted #3dad8f;
      padding: 5px;
      width: 500px;
    }
    .radioBox {
      margin: 5px 10px;
      border: 1px dotted #3dad8f;
      padding: 5px;
      width: 500px;
    }
  }
}

.centerBigBox {
  height: 300px;
  display: flex;
  flex-direction: column;
  margin: 0 50px;
  .smallBox {
    display: flex;
    align-items: center;
    .Title {
      color: #06c0f3;
      width: 150px;
    }
    .inputBox {
      // margin: 0 10px;
      width: 400px;
    }
    .checkboxBox {
      margin: 11.5px 10px;
      border: 1px dotted #3dad8f;
      padding: 5px;
      width: 500px;
    }
    .radioBox {
      margin: 11.5px 10px;
      border: 1px dotted #3dad8f;
      padding: 5px;
      width: 500px;
      text-align: center;
    }
  }
}

// 特效input
.card-slide {
  display: inline-block;
  width: 400px;
  padding: 10px 0 10px 15px;
  margin: 0 10px 0 0;
  font-family: "Open Sans", sans;
  font-weight: 400;
  color: #377d6a;
  background: #efefef;
  border: 0;
  border-radius: 3px;
  outline: 0;
  text-indent: 80px; // Arbitrary.
  transition: all 0.3s ease-in-out;

  &::-webkit-input-placeholder {
    color: #efefef;
    text-indent: 0;
    font-weight: 300;
  }

  + label {
    display: block;
    position: absolute;
    left: 3.3%;
    // height: 20px;
    padding: 10px 15px;
    text-shadow: 0 1px 0 rgba(19, 74, 70, 0.4);
    background: #377d6a;

    color: floralwhite;
    transition: all 0.3s ease-in-out;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    transform-origin: right center;
    transform: perspective(300px) scaleX(1) rotateY(0deg);
  }
}
span:nth-child(2) .card-slide {
  text-indent: 55px;
}
span:nth-child(3) .card-slide {
  text-indent: 150px;
}
span:nth-child(2) .card-slide:focus,
span:nth-child(2) .card-slide:active,
span:nth-child(3) .card-slide:focus,
span:nth-child(3) .card-slide:active {
  text-indent: 0;
}
.card-slide:focus,
.card-slide:active {
  color: #377d6a;
  text-indent: 0;
  background: #fff;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;

  &::-webkit-input-placeholder {
    color: #aaa;
  }
  + label {
    transform: perspective(600px) translateX(-100%) rotateY(80deg);
  }
}
// 特效input
.gate {
  display: inline-block;
  width: 400px;
  padding: 10px 0 10px 15px;
  margin-right: 10px;
  font-family: "Open Sans", sans;
  font-weight: 400;
  color: #377d6a;
  background: #efefef;
  border: 0;
  border-radius: 3px;
  outline: 0;
  text-indent: 80px; // Arbitrary.
  transition: all 0.3s ease-in-out;

  &::-webkit-input-placeholder {
    color: #efefef;
    text-indent: 0;
    font-weight: 300;
  }

  + label {
    display: inline-block;
    position: absolute;

    // top: 0;
    left: 36.5%;
    padding: 10px 15px;
    text-shadow: 0 1px 0 rgba(19, 74, 70, 0.4);
    background: #7ab893;
    color: floralwhite;
    transition: all 0.4s ease-in-out;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    transform-origin: left bottom;
    z-index: 99;

    &:before,
    &:after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: 3px;
      background: #377d6a;
      transform-origin: left bottom;
      transition: all 0.4s ease-in-out;
      pointer-events: none;
      z-index: -1;
    }
    &:before {
      background: rgba(3, 36, 41, 0.2);
      z-index: -2;
      right: 20%;
    }
  }
}
span:nth-child(2) .gate {
  text-indent: 85px;
}
span:nth-child(2) .gate:focus,
span:nth-child(2) .gate:active {
  text-indent: 0;
}
.gate:focus,
.gate:active {
  color: #377d6a;
  text-indent: 0;
  background: #fff;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;

  &::-webkit-input-placeholder {
    color: #aaa;
  }
  + label {
    transform: rotate(-66deg);
    border-radius: 3px;

    &:before {
      transform: rotate(10deg);
    }
  }
}

// 多选框样式
.el-checkbox {
  color: rgb(255, 254, 251);
}

// 单选样式
/deep/.el-radio__label {
  color: rgb(255, 254, 251);
}

/deep/.el-upload-list__item-name {
  color: #17c3f7;
  display: block;
  // margin-right: 40px;
  overflow: hidden;
  padding-left: 4px;
  text-overflow: ellipsis;
  transition: color 0.3s;
  white-space: nowrap;
  max-width: 200px;
}

// 下拉选择框
/deep/.el-select .el-input__inner {
  color: #377d6a !important;
  background-color: #efefef !important;
  border: 1px solid #efefef !important;
}

/deep/.logoLabel label {
  line-height: 100px;
  text-align: left;
}

// LOGO上传卡片
/deep/.el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}

// 图片上传预览时点击样式
// /deep/.el-upload-list__item-actions {
//   width: 100px;
//   height: 100px;
// }
// // 图片上传预览时点击样式
// /deep/.el-upload-list__item {
//   width: 100px;
//   height: 100px;
// }
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 100px !important;
  height: 100px !important;
}

.upload_Logo {
  display: inline-block;
  width: 400px;
  height: 100px;
  margin-right: 30px;
}

// 图片上传样式
/deep/.disabled {
  .el-upload--picture-card {
    display: none;
  }
}
//隐藏上传以及删除时得效果
/deep/.el-upload-list__item {
  transition: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/ServerManager/centralServerConfig.vue